angular.module('leanlaw').factory('clientUserTagDefinition', ['singleRequest', function (singleRequest) {
  const includeOptions = {
    wip: {
      label: 'WIP',
      data: 'hours,services,expenses,charges',
      filter: {
        billed: false
      },
      columns: ['wipTotal']
    },
    wipOverview: {
      label: 'WIP Overview',
      data: 'services,expenses,charges',
      filter: {
        billed: false
      },
      columns: ['wipServices', 'wipExpenses']
    },
    billableDetail: {
      label: 'Billable Detail',
      data: 'hours,services,expenses,charges',
      columns: ['billableHoursAmount', 'billableExpenses', 'billableCharges', 'billableTotal']
    },
    billed: {
      label: 'Billed',
      data: 'invoices',
      columns: ['billedTotal']
    },
    billedOverview: {
      label: 'Billed Overview',
      data: 'invoices',
      columns: ['billedServices', 'billedExpenses']
    },
    collected: {
      label: 'Collected',
      data: 'payments',
      columns: ['collectedTotal']
    },
    collectedDetail: {
      label: 'Collected Detail',
      data: 'payments',
      columns: ['collectedServices', 'collectedExpenses', 'collectedTotal']
    },
    collectedOverview: {
      label: 'Collected Overview',
      data: 'payments',
      columns: ['collectedServices', 'collectedExpenses']
    },
    trust: {
      label: 'Trust',
      data: 'trust',
      columns: ['trust']
    },
    balance: {
      label: 'Account Balance',
      data: 'receivables',
      columns: ['balance']
    }
  };
  const headersFromType = type => {
    if (type === 'client') {
      return [{
        id: 'reference',
        label: 'ID'
      }, {
        id: 'name',
        label: `Client/Matter`,
        matterPrefix: true
      }];
    }
    if (type === 'user') {
      return [{
        id: 'name',
        label: 'Name'
      }];
    }
    if (type === 'matterTag') {
      return [{
        id: 'label',
        label: 'Practice Area'
      }];
    }
    throw Error("Missing or unknown report type");
  };
  const allColumns = [{
    id: 'billableNonBillable',
    label: 'Hours Non-Billable',
    filter: 'hoursDecimal',
    number: true
  }, {
    id: 'billableHours',
    label: 'Hours Billable',
    filter: 'hoursDecimal',
    number: true
  }, {
    id: 'billableHoursAmount',
    label: 'Hours Amount',
    filter: 'amount',
    number: true
  }, {
    id: 'billableCharges',
    label: 'Fixed Fees',
    filter: 'amount',
    number: true
  }, {
    id: 'billableExpenses',
    label: 'Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'billableTotal',
    label: 'Total Amount',
    filter: 'amount',
    number: true
  }, {
    id: 'wipServices',
    label: 'WIP Services',
    filter: 'amount',
    number: true
  }, {
    id: 'wipExpenses',
    label: 'WIP Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'wipTotal',
    label: 'WIP',
    filter: 'amount',
    number: true
  }, {
    id: 'billedServices',
    label: 'Billed Services',
    filter: 'amount',
    number: true
  }, {
    id: 'billedExpenses',
    label: 'Billed Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'billedTotal',
    label: 'Billed',
    filter: 'amount',
    number: true
  }, {
    id: 'collectedServices',
    label: 'Collected Services',
    filter: 'amount',
    number: true
  }, {
    id: 'collectedExpenses',
    label: 'Collected Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'collectedTotal',
    label: 'Collected Total',
    filter: 'amount',
    number: true
  }, {
    id: 'trust',
    label: 'Trust Balance',
    filter: 'amount',
    number: true
  }, {
    id: 'balance',
    label: 'Account Balance',
    filter: 'amount',
    number: true
  }];
  function columnDecorator(params) {
    // Based on params, set the data prop and additional filter properties
    const includeIds = params.include.split(',');
    const filter = {};
    let data = [];
    includeIds.forEach(includeId => {
      const include = includeOptions[includeId];
      data = data.concat(include.data.split(','));
      Object.assign(filter, include.filter);
    });
    return {
      ...filter,
      data: data.join(',')
    };
  }
  const cancel = params => {
    singleRequest.cancel(params.type);
  };
  const load = config => ({
    query,
    params
  }) => {
    const {
      type
    } = params;
    const headers = headersFromType(type);
    query.primary = `${type.toLowerCase()}s`;
    query.zeros = false;
    Object.assign(query, columnDecorator(params));
    if (config) {
      Object.assign(query, config(params).query);
    }
    return singleRequest.apiCall(type).getReport(query).then(result => {
      if (!result) return undefined;
      return {
        rows: result[`${type}s`].map(c => {
          const row = rowFromData(c[type.toLowerCase()], c.data, headers);
          if (type === 'client') {
            row.rows = c.matters.map(m => rowFromData(m.matter, m.data, headers));
          }
          return row;
        })
      };
    });
  };
  function rowFromData(item, data, headers) {
    const values = headers.reduce((vs, h) => {
      vs[h.id] = {
        value: item[h.id]
      };
      return vs;
    }, {});
    if (data.hours) {
      values.billableNonBillable = {
        value: data.hours.nonBillable
      };
      values.billableHours = {
        value: data.hours.billable
      };
    }
    if (data.amounts) {
      values.billableHoursAmount = {
        value: data.amounts.hours
      };
      values.billableCharges = {
        value: data.amounts.charges
      };
      values.billableExpenses = {
        value: data.amounts.expenses
      };
      values.billableServices = {
        value: data.amounts.hours + data.amounts.charges
      };
      values.billableTotal = {
        value: data.amounts.total
      };
      values.wipServices = values.billableServices;
      values.wipExpenses = values.billableExpenses;
      values.wipTotal = values.billableTotal;
    }
    if (data.invoiced) {
      values.billedTotal = {
        value: data.billed.total
      };
      values.billedExpenses = {
        value: data.billed.expensesTotal
      };
      values.billedServices = {
        value: data.billed.servicesTotal
      };
    }
    if (data.collected) {
      values.collectedServices = {
        value: data.collected.servicesTotal
      };
      values.collectedExpenses = {
        value: data.collected.expensesTotal
      };
      values.collectedTotal = {
        value: data.collected.total
      };
    }
    if (data.accounting) {
      values.trust = {
        value: data.accounting.trustBalance
      };
      values.balance = {
        value: data.accounting.balance
      };
    }
    return {
      id: item.id,
      label: item.label || item.name,
      values
    };
  }
  const structure = config => ({
    params,
    me
  }) => {
    const columns = headersFromType(params.type);
    const totalLabelCells = columns.length;
    const includeIds = params.include.split(',');
    const showFilters = config && config(params).show;
    includeIds.forEach(includeId => {
      const include = includeOptions[includeId];
      include.columns.forEach(columnId => {
        columns.push(allColumns.find(c => c.id === columnId));
      });
    });
    console.log('columns', columns);
    return {
      sort: columns[0].id,
      subrow: {
        label: params.type === 'client' ? `${me.terms.Matter}s` : undefined
      },
      totals: {
        rows: true,
        columns: false,
        totalLabelCells
      },
      showFilters: {
        dateRange: true,
        matterForUser: true,
        distribution: params.include === 'collected' || params.include === 'collectedDetail',
        ...showFilters
      },
      columns
    };
  };
  return config => ({
    structure: structure(config),
    load: load(config),
    cancel
  });
}]);